import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { useCalendarLookupStore } from '@/stores/useCalendarLookupStore'
import { CalendarLookupTable } from './CalendarLookupTable'

/**
 * READ-ONLY viewer for the preloaded calendar lookup table, opened from the
 * "Select from Calendar" value chooser. Mounted once in CltWizard. The table is
 * shared with the standalone admin page (CalendarLookupTable).
 */
export function CalendarLookupDialog() {
  const isOpen = useCalendarLookupStore(s => s.isOpen)
  const close = useCalendarLookupStore(s => s.close)

  return (
    <Dialog open={isOpen} onOpenChange={next => !next && close()}>
      <DialogContent className="sm:max-w-[680px]">
        <DialogHeader>
          <DialogTitle>Calendar lookup table</DialogTitle>
          <DialogDescription>
            Preloaded, read-only reference. PAW End / POG Complete per Calendar
            Year × Event × DC — a “Select from Calendar” rule reads these per
            event at instantiation.
          </DialogDescription>
        </DialogHeader>

        <CalendarLookupTable />
      </DialogContent>
    </Dialog>
  )
}
